import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AbbyResponse } from './abby-response.model';


@Injectable({
  providedIn: 'root'
})
export class AbbyService {

  constructor(private http: HttpClient) {  }

  processMRZ(document: any): Promise<any> {
    const headers = new HttpHeaders({
      'Content-Type': document.type
    });
    const options = { headers: headers };

    return this.http.post(`${environment.BASE_URL_BTP}abbyy/processMRZ`, document, options)
      .toPromise()
      .catch(this.handleError);
  }

  getTaskResult(taskId: string): Promise<AbbyResponse> {
    return this.getTaskStatus(taskId).then((res: any) => {
      const taskStatus = res.response.task[0]['$'].status;
      const timeoutValue = 500;

      return taskStatus === 'Completed' ? res.results : new Promise((resolve) =>
          setTimeout(() => resolve(this.getTaskResult(taskId)), timeoutValue)
        );
    });
  }

  getTaskStatus(taskId: string): Promise<any> {
    return this.http.get(`${environment.BASE_URL_BTP}abbyy/getTaskStatus/?taskId=${taskId}`)
      .toPromise()
      .catch(this.handleError);
  }

  private handleError(error: HttpErrorResponse | any) {
    let errMsg: string;
    if (error instanceof HttpErrorResponse) {
      const body = error.error || '';
      const err = body.errorMessage || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    return Promise.reject(errMsg);
  }
}
